export const featureFlags = {
  /** Фильтр интерфейсов по категории (Ethernet / Docker / VMware / Other) в карточке хоста */
  hostInterfaceCategoryFilter: false,
  /**
   * Авто-выключение агентов с dead_dttm и расходящимся state (RUNNING/UNKNOWN)
   * при загрузке карты сети (см. hostsStore.ensureTurnOffForDeadHostsIfNeeded).
   * Временно выключено для проверки работы системы без этой автоматики.
   * Ручную кнопку "Выключить агента" (AdvancedHostCard) и forceRestrictedAgent
   * (enforcing) не затрагивает.
   */
  autoTurnOffDeadHosts: false,
  /**
   * Фильтры «Частота источника» / «Частота назначения» в FilterPopover
   * рекомендаций и правил карточек интерфейса, группы и внешнего узла (задача 344).
   * Скрыты по фидбеку лида — пока не нужны.
   */
  recommendationFrequencyFilters: false,
} as const;
